<template>
	<div>
		<Popup v-model="list_display" title="AI检查评估报告" :confirmBtnDisplay="false">
			<div v-loading="list_loading" style="padding: 15px;">
				<div class="base_table">
					<el-table :data="list_data" style="width: 100%">
						<el-table-column prop="name" label="姓名"></el-table-column>
						<el-table-column prop="mobile" label="手机号"></el-table-column>
						<el-table-column prop="sex" label="性别"></el-table-column>
						<el-table-column prop="age" label="年龄"></el-table-column>
						<el-table-column prop="time" label="检测时间"></el-table-column>
						<el-table-column label="操作" width="150">
							<template slot-scope="scope">
								<el-button @click="handleViewClick(scope.row)">查看</el-button>
							</template>
						</el-table-column>
					</el-table>
				</div>
			</div>
		</Popup>

		<Popup v-model="report_display" title="AI检查评估报告" :confirmBtnDisplay="false">
			<div v-loading="report_loading" class="AI_report" style="padding: 15px;">
				<h3 class="tit">AI检查评估报告</h3>
				<p class="sub_tit">基本信息</p>
				<ul class="user_info clear_both">
					<li style="width: 20%;">姓名：{{ report_basicInfo.name }}</li>
					<li style="width: 20%;">性别：{{ report_basicInfo.sex }}</li>
					<li style="width: 20%;">年龄：{{ report_basicInfo.age }}</li>
					<li style="width: 40%;">检测时间：{{ report_basicInfo.time }}</li>
				</ul>
				<table class="base_doc" style="margin-top: 20px;">
					<tr class="b_tt">
						<td style="text-align: center;">项目/眼别</td>
						<td style="text-align: center;">右眼</td>
						<td style="text-align: center;">左眼</td>
						<td style="text-align: center;">双眼</td>
					</tr>
					<tr>
						<td>裸眼视力</td>
						<td>{{ report_basicInfo.nakedR }}</td>
						<td>{{ report_basicInfo.nakedL }}</td>
						<td>{{ report_basicInfo.nakedD }}</td>
					</tr>
					<tr>
						<td>矫正视力</td>
						<td>{{ report_basicInfo.correctR }}</td>
						<td>{{ report_basicInfo.correctL }}</td>
						<td>{{ report_basicInfo.correctD }}</td>
					</tr>
				</table>
				<p class="sub_tit">检测结果</p>
				<ul class="check_list">
					<li v-for="v in report_list" :key="v.id">
						<div class="side_view">
							<div class="icon">
								<img :src="v.icon" alt="">
							</div>
							<p style="font-weight: bold;">{{ v.label }}</p>
							<div class="pointer_view">
								<div class="pointer" :style="{left: v.per + '%'}">
									<div style="color: #666;text-align: center;">{{ v.per }}%</div>
									<img src="../../../../../assets/images/arrow_1.png"
										style="display: block;width: 10px;height: 7px;margin: 0 auto;" />
								</div>
							</div>
							<div class="progress clear_both">
								<div class="error bg_danger"></div>
								<div class="warn bg_warn"></div>
								<div class="success bg_theme"></div>
							</div>
							<div class="labels clear_both">
								<div class="error_label">较差</div>
								<div class="warn_label">一般</div>
								<div class="success_label">良好</div>
							</div>
						</div>
						<p style="margin-top: 10px;color: #666;line-height: 30px;">解读：{{ v.context }}</p>
					</li>
				</ul>
				<p class="sub_tit">视觉能力图</p>
				<div ref="radar_chart"
					style="height: 450px;margin-top: 20px;border: 1px solid #ccc;border-radius: 10px;"></div>
			</div>
		</Popup>
	</div>
</template>

<script>
	import Api from '../../../../../api/index.js';
	import {
		mapState
	} from 'vuex';
	import Echarts from "echarts";

	export default {
		model: {
			prop: 'display',
			event: 'changeDisplay'
		},
		props: {
			display: Boolean,
			obj: {
				type: Object,
				default: () => {
					return {};
				}
			}
		},
		mounted() {
			this.display && (this.list_display = true);
		},
		data() {
			return {
				list_display: false,
				list_loading: false,
				list_data: [],

				report_display: false,
				report_loading: false,
				report_basicInfo: {
					name: '',
					age: '',
					time: '',
					nakedL: '/',
					nakedR: '/',
					nakedD: '/',
					correctL: '/',
					correctR: '/',
					correctD: '/'
				},
				report_list: []
			}
		},
		computed: {
			...mapState([
				'allDetectionType'
			])
		},
		methods: {
			/************************* @List *************************/
			// 获取列表
			getList() {
				const that = this;
				that.list_loading = true;
				let requestData = {
					wUserId: that.obj.id
				};
				Api.findAIReportByUser(requestData).then((res) => {
					that.list_loading = false;
					if (res.data.success) {
						let list = [];
						res.data.data.forEach(v => {
							list.push({
								id: v.globalId,
								name: v.wuser.uLName,
								mobile: v.wuser.uPhone,
								sex: v.wuser.uSex == 0 ? '男' : (v.wuser.uSex == 1 ? '女' : ''),
								age: v.wuser.uAge,
								time: v.createTs
							});
						});
						that.list_data = list;
					} else {
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.list_loading = false;
					that.$message.error(e.message);
				});
			},
			// 点击查看
			handleViewClick(data) {
				this.report_display = true;
				this.getData(data.id);
			},
			// 得到检测类型
			mapTypeToLabel(type) {
				let label = '';
				this.allDetectionType.forEach(v => {
					type == v.id && (label = v.name);
				});
				return label;
			},

			/************************* @Report *************************/
			// 获取数据
			getData(id) {
				const that = this;
				that.report_loading = true;
				Api.getDetailForAIReport(id).then((res) => {
					that.report_loading = false;
					if (res.data.success) {
						that.initBasicInfoData(res.data.data.wuser);
						that.initResultData(res.data.data.list);
						that.initRadar();
					} else {
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.report_loading = false;
					that.$message.error(e.message);
				});
			},
			// 初始化基本信息数据
			initBasicInfoData(data) {
				this.report_basicInfo = {
					name: data.uLName || '',
					sex: data.uSex == 0 ? '男' : (data.uSex == 1 ? '女' : ''),
					age: data.uAge,
					time: data.uCreateTs,
					nakedL: data.uLeftNeva || '/',
					nakedR: data.uRightNeva || '/',
					nakedD: data.uDoubleNeva || '/',
					correctL: data.uLeftCva || '/',
					correctR: data.uRightCva || '/',
					correctD: data.uDoubleCva || '/'
				};
			},
			initResultData(list) {
				let arr = [];
				list.forEach(v => {
					let icon = '';
					let label = '';
					if (v.testType == 1) { // 光栅锐度能力
						icon = `https://haokan-miniapp-resources.oss-cn-beijing.aliyuncs.com/report/1.png`;
						label = '光栅锐度能力';
					}
					if (v.testType == 2) { // 截止频率能力
						icon = `https://haokan-miniapp-resources.oss-cn-beijing.aliyuncs.com/report/2.png`;
						label = '截止频率能力';
					}
					if (v.testType == 3) { // 游标锐度能力
						icon = `https://haokan-miniapp-resources.oss-cn-beijing.aliyuncs.com/report/3.png`;
						label = '游标锐度能力';
					}
					if (v.testType == 4) { // 纹理感知能力
						icon = `https://haokan-miniapp-resources.oss-cn-beijing.aliyuncs.com/report/4.png`;
						label = '纹理感知能力';
					}
					if (v.testType == 5) { // 纹理运动辨别能力
						icon = `https://haokan-miniapp-resources.oss-cn-beijing.aliyuncs.com/report/5.png`;
						label = '纹理运动辨别能力';
					}
					if (v.testType == 6) { // 光栅运动辨别能力
						icon = `https://haokan-miniapp-resources.oss-cn-beijing.aliyuncs.com/report/6.png`;
						label = '光栅运动辨别能力';
					}
					if (v.testType == 7) { // 噪音排除能力
						icon = `https://haokan-miniapp-resources.oss-cn-beijing.aliyuncs.com/report/7.png`;
						label = '噪音排除能力';
					}
					if (v.testType == 8) { // 色觉敏感度
						icon = `https://haokan-miniapp-resources.oss-cn-beijing.aliyuncs.com/report/8.png`;
						label = '色觉敏感度';
					}
					if (v.testType == 1 || v.testType == 2 || v.testType == 3 || v.testType == 4 || v.testType ==
						5 || v.testType == 6 || v.testType == 7 || v.testType == 8) {
						arr.push({
							icon: icon,
							label: label,
							context: v.context,
							per: v.percent
						});
					}
				});
				this.report_list = arr.reverse();
				console.log(this.report_list)
			},
			initRadar() {
				let labels = [];
				let pers = [];
				let indicator = [];
				this.report_list.forEach(v => {
					labels.push(`${ v.label }`);
					pers.push(v.per);
					indicator.push({
						name: v.label,
						max: 100
					});
				});
				this.tableEchart = Echarts.init(this.$refs.radar_chart);
				let option = {
					radar: {
						indicator,
						startAngle: 135,
					},
					series: [{
						type: 'radar',
						label: {
							show: true,
							color: '#333'
						},
						lineStyle: {
							color: '#277fe5'
						},
						data: [{
							value: pers
						}]
					}]
				};
				this.tableEchart.setOption(option);
			}
		},
		watch: {
			display(newValue) {
				this.list_display = newValue;
			},
			list_display(newValue) {
				this.$emit('changeDisplay', newValue);
				if (newValue) {
					this.getList();
				} else {
					this.list_loading = false;
					this.list_data = [];
				}
			},
			report_display(newValue) {
				if (!newValue) {
					this.report_loading = false;
					this.report_basicInfo = {
						name: '',
						age: '',
						time: '',
						nakedL: '/',
						nakedR: '/',
						nakedD: '/',
						correctL: '/',
						correctR: '/',
						correctD: '/'
					};
					this.report_list = [];
				}
			}
		}
	}
</script>

<style>
	.AI_report .tit {
		font-size: 24px;
		font-weight: bold;
		text-align: center;
		line-height: 50px;
	}

	.AI_report .sub_tit {
		margin-top: 40px;
		font-size: 20px;
		text-align: center;
		line-height: 30px;
	}

	.AI_report .user_info {
		margin-top: 20px;
	}

	.AI_report .user_info li {
		float: left;
	}

	.AI_report .check_list li {
		padding: 20px;
		border-bottom: 1px dashed #ccc;
	}

	.AI_report .check_list .side_view {
		position: relative;
		min-height: 160px;
		padding: 0 0 0 180px;
	}

	.AI_report .check_list .icon {
		display: block;
		position: absolute;
		width: 160px;
		height: 160px;
		top: 0;
		left: 0;
	}

	.AI_report .check_list img {
		display: block;
		width: 100%;
		height: 100%;
	}

	.AI_report .pointer_view {
		position: relative;
		height: 31px;
		margin-top: 10px;
	}

	.AI_report .pointer {
		position: absolute;
		width: 60px;
		top: 0;
		margin-left: -30px;
	}

	.AI_report .progress {
		height: 6px;
		margin-top: 4px;
	}

	.AI_report .error {
		float: left;
		width: 30%;
		height: 100%;
	}

	.AI_report .warn {
		float: left;
		width: 40%;
		height: 100%;
	}

	.AI_report .success {
		float: left;
		width: 30%;
		height: 100%;
	}

	.AI_report .labels {
		margin-top: 4px;
		color: #666;
	}

	.AI_report .error_label {
		float: left;
		width: 30%;
	}

	.AI_report .warn_label {
		float: left;
		width: 40%;
	}

	.AI_report .success_label {
		float: left;
		width: 30%;
	}
</style>
